import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import Spinner from "../Spinner/Spinner";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function UpdateTurnOver() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [listPerpage, setListPerpage] = useState(10);
  const [leftreferralApi, setLeftreferralApi] = useState([]);
  const [amount, setAmount] = useState("");

  const columns = [
    { Header: "S.No", accessor: "sr" },
    { Header: "Amount", accessor: "amount" },
    { Header: "Date & Time", accessor: "dd" },
  ];

  const logoutUser = () => {
    dispatch(
      updateAuth({
        AdminAuth: false,
        jwt_token: "",
        userId: null,
      }),
    );

    sessionStorage.clear();
    localStorage.clear();
    navigate("/");
  };

  const referral_API = async () => {
    setIsLoading(true);

    try {
      const response = await API.post(
        "/Adminreport",
        {
          loginid: userId,
          uid: "",
          fdate: "",
          tdate: "",
          report: "UpdateTurnOver",
          status: "2",
          level: "0",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      const data = response?.data?.data?.[0] || [];

      const tableData = data.map((item, index) => ({
        sr: index + 1,
        amount: item.amount,
        dd: item.dd,
      }));

      setLeftreferralApi(tableData);
    } catch (e) {
      console.log(e);

      if (
        e?.response?.data?.showableMessage ===
        "Please login to access this resource"
      ) {
        logoutUser();
      } else {
        toast.error("Unable to load data.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const UpdateTurnOver_API = async () => {
    if (!amount || Number(amount) <= 0) {
      toast.error("Please enter a valid amount.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await API.post(
        "/UpdateTurnOver",
        {
          loginid: userId,
          amount: amount,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      if (response?.data?.data === "Amount Saved !!") {
        toast.success(response?.data?.data || "Updated Successfully");
      } else {
        toast.error(response?.data?.data);
      }

      setAmount("");

      referral_API();
    } catch (e) {
      console.log(e);

      if (
        e?.response?.data?.showableMessage ===
        "Please login to access this resource"
      ) {
        logoutUser();
      } else {
        toast.error(
          e?.response?.data?.showableMessage || "Something went wrong.",
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;

  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  return (
    <div>
      <Navbar />

      <div className="content-page">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4 className="panel-title">Update Turn Over</h4>
                </div>

                <div className="panel-body">
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Amount"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                      />
                    </div>

                    <div className="col-md-3">
                      <button
                        className="btn btn-primary"
                        onClick={UpdateTurnOver_API}
                        disabled={isLoading}
                      >
                        {isLoading ? "Please Wait..." : "Submit"}
                      </button>
                    </div>
                  </div>

                  <div className="row">
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={columns} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          currentPage={currentPage}
                          setcurrentPage={setCurrentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setListPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateTurnOver;
